import { Component, OnInit, Input } from '@angular/core';
import { IRegistroVentasItem } from '../interfaces/IRegistroVentaItems';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatDate, DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-registroventasitem',
  templateUrl: './registroventasitem.component.html',
  styleUrls: ['./registroventasitem.component.css']
})
export class RegistroventasitemComponent implements OnInit {
  constructor(private registroServicios: RegistroVentasService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService) { }

  @Input() ItemRegistro: IRegistroVentasItem;
  @Input() FechaRegistro: any;
  @Input() CategotiasBaresComidas: string[];

  enabledButton: boolean;
  valido: boolean;
  seleccion=true;
  active=true;
  selectedwithTax!:boolean
  hiperMercado : string = '14'
  
  ngOnInit(): void {
    this.enabledButton = true;
  }

  isValidVentas(ventas:string):boolean{
    return ventas === '' || (parseInt(ventas) < 1000 && parseInt(ventas) != 0)
  }

  saveRegistroVentas(Categoria:string) {
    if (Categoria === this.hiperMercado) {
      this.selectedwithTax = true
    }
    if(this.selectedwithTax != undefined){
        let result;
      this.ItemRegistro.FechaRegistro = this.FechaRegistro == undefined ? new Date() : this.FechaRegistro;
      this.ItemRegistro.Usuario = environment.userEmailLogged;
      this.ItemRegistro.FueAbierto = this.seleccion;
      this.ItemRegistro.Productos = this.ItemRegistro.Productos == null ? "0": this.ItemRegistro.Productos.toString();
      this.ItemRegistro.Facturas = this.ItemRegistro.Facturas== null ? "": this.ItemRegistro.Facturas.toString();
      this.ItemRegistro.Trafico = this.ItemRegistro.Trafico == null? "0": this.ItemRegistro.Trafico.toString();
      this.ItemRegistro.Presupuesto = this.ItemRegistro.Presupuesto == null? "0": this.ItemRegistro.Presupuesto.toString();
      this.ItemRegistro.VentasSinCalcular = this.ItemRegistro.Ventas;
      this.ItemRegistro.TieneImpusto = this.selectedwithTax
      
      this.compareTwoDates(this.ItemRegistro.FechaRegistro);

      if (this.valido) {
        if(this.seleccion)
        {      
          if(this.isValidVentas(this.ItemRegistro.Ventas)){
            this.toaster.warning('Campo ventas', 'Ingrese un valor de ventas valido');
          }
          else if( this.ItemRegistro.Facturas == ''){
            this.toaster.warning('Campo facturas', 'Para continuar con el registro es necesario ingresar el.');
          }
          else{            
            if (this.CategotiasBaresComidas.includes(this.ItemRegistro.Categoria)) {
              this.aplicarImpuesto(0.08);
          } else {
              this.aplicarImpuesto(0.19);
          }
            
            this.spinner.show();
            this.registroServicios.saveRegistroVentas(this.ItemRegistro)
              .subscribe(e => {
                result = e;
                if (result) {
                  this.toaster.success('Pactia Ventas', 'Se ha guardado con éxito!.');
                  this.limpiarValores();
                }
                else {
                  this.toaster.warning('Pactia Ventas', 'Ya existe un registro de venta para esta marca, si quiere modificarla vaya a la opción de consulta.');
                  this.limpiarValores();
                }
                this.spinner.hide();
    
              }, (error: ErrorResponse) => {
                console.error(error);
                this.spinner.hide();
              }
    
            );
          }
        }else{
          this.ItemRegistro.Ventas = ""
            this.ItemRegistro.Facturas = "";
            this.ItemRegistro.Productos = "";
            this.ItemRegistro.Trafico = "";
        
            this.spinner.show();
              this.registroServicios.saveRegistroVentas(this.ItemRegistro)
              .subscribe(e => {
                result = e;
                if (result) {
                  this.toaster.success('Pactia Ventas', 'Se ha guardado con éxito!.');
                  this.limpiarValores();
                }
                else {
                  this.toaster.warning('', 'Ya existe un registro de venta para esta marca, si quiere modificarla vaya a la opción de consulta.');
                  this.limpiarValores();
                }
                this.spinner.hide();
    
              }, (error: ErrorResponse) => {
                console.error(error);
                this.spinner.hide();
              });
          }
        
      }
      else {
        this.spinner.hide();
        this.toaster.error('', 'La fecha en que esta registrando la venta no debe ser mayor a la fecha actual.');

      }
    }else{
      this.toaster.warning('', 'Por favor, seleccione una de las opciones disponibles sobre los impuestos antes de continuar.');
    }
  }

  limpiarValores() {
    this.ItemRegistro.Ventas = '';
    this.ItemRegistro.Facturas = '';
    this.ItemRegistro.Productos = '';
    this.ItemRegistro.Trafico = '';
    this.ItemRegistro.Presupuesto = '';
  }
  private aplicarImpuesto(impuesto: number): void {
    let ventasNumber: number = parseFloat(this.ItemRegistro.Ventas) || 0;

    this.ItemRegistro.Ventas = Math.floor(
        this.selectedwithTax 
            ? ventasNumber 
            : ventasNumber - (ventasNumber * impuesto)
    ).toString();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onBlurMethod() {
   
  }


  compareTwoDates(fecha: any) {
    var fechaFormato = formatDate(fecha, 'yyyy/MM/dd', 'en-US');
    if (new Date(fechaFormato) > new Date()) {
      this.valido = false;
    }
    else {
      this.valido = true;
    }
  }


  opciones = [
    { id: true, name: 'Si hubo apertura' },
    { id: false, name: 'No hubo apertura' }
  ];

  optionsTax(type:boolean):string{
    if(this.CategotiasBaresComidas.includes(this.ItemRegistro.Categoria)){
      if(type){
        return "Sin Impoconsumo"
      }
      return "Con Impoconsumo"
    }else{
      if(type){
        return "sin iva"
      }
      return "con iva"
    }
  }
  
  
}
